import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useCurrentUserDetails } from 'entities/user/model';

export const useCreateBillByVendorInvoice = () => {
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  const { getAccessTokenSilently } = useAuth0();
  const mutation = useMutation({
    mutationKey: ['quickbooks-bill-by-vendor-invoice'],
    mutationFn: async ({
      invoicePaymentRequestId,
      qbVendorId,
      qbAccountId,
      qbTaxAmount,
    }: {
      invoicePaymentRequestId: string;
      qbVendorId: string;
      qbAccountId: string;
      qbTaxAmount: string;
    }) => {
      const token = await getAccessTokenSilently();
      const resp = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/public/quick-books-online/bill-by-vendor-invoice`,
        {
          organizationId: getCurrentOrganizationId(),
          invoicePaymentRequestId,
          qbVendorId,
          qbAccountId,
          qbTaxAmount: String(qbTaxAmount),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return resp.data?.result;
    },
  });

  return mutation;
};
